(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[124],{

/***/ 49523:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/aboutUs/service",
      function () {
        return __webpack_require__(99290);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 99290:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSG": function() { return /* binding */ __N_SSG; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _layout_MainLayout__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(81842);
/* harmony import */ var _components_common_Redirect_redirect__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(58697);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(67294);





function Service() {
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_3__.useRouter)();
    (0,react__WEBPACK_IMPORTED_MODULE_4__.useEffect)(function() {
        setTimeout(function() {
            router.replace("/legalCenter/termsOfService");
        }, 100);
    }, []);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_layout_MainLayout__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_common_Redirect_redirect__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {})
    });
}
var __N_SSG = true;
/* harmony default export */ __webpack_exports__["default"] = (Service);


/***/ }),

/***/ 58697:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _redirect_module_scss__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(10660);
/* harmony import */ var _redirect_module_scss__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_redirect_module_scss__WEBPACK_IMPORTED_MODULE_1__);


function Redirect() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: (_redirect_module_scss__WEBPACK_IMPORTED_MODULE_1___default().container),
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            className: (_redirect_module_scss__WEBPACK_IMPORTED_MODULE_1___default().ring)
        })
    });
}
/* harmony default export */ __webpack_exports__["Z"] = (Redirect);


/***/ }),

/***/ 10660:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"redirect_container__VLKum","ring":"redirect_ring__VH6gQ","ringA":"redirect_ringA__tZ5Te"};

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [3123,1842,9774,2888,179], function() { return __webpack_exec__(49523); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);